/**
 * Ссылки на картинки Instagram подписаны и живут около двух недель: срок
 * зашит в параметр `oe` шестнадцатеричным unix-временем. После него CDN
 * отдаёт 403, и аватарки в интерфейсе молча превращаются в инициалы.
 */
export function signedUrlExpiresAt(url: string | null | undefined): Date | null {
  if (!url) return null;
  const match = /[?&]oe=([0-9A-Fa-f]+)/.exec(url);
  if (!match) return null;
  const seconds = parseInt(match[1], 16);
  return Number.isFinite(seconds) ? new Date(seconds * 1000) : null;
}

/** Протухла ли ссылка (или протухнет в ближайшие `withinMs`). */
export function isSignedUrlStale(url: string | null | undefined, withinMs = 0): boolean {
  const expiresAt = signedUrlExpiresAt(url);
  if (!expiresAt) return false;
  return expiresAt.getTime() - Date.now() < withinMs;
}
